import { ModalCloseButton } from '@chakra-ui/react';

export default function CloseButton(props) {
	return <ModalCloseButton color='#000' bg='transparent' border='none' _hover={{ color: '#5D1AB2', border: '1px solid #5D1AB2'}} {...props} />;
}

// _focus={{ boxShadow: 'none', outline: 'none' }}